import { HeaderSettingsForm } from '@app/components/forms/header-settings-form'
import { Binding, PersistButton } from '@app/lib/binding'
import { BackButton } from '@app/lib/buttons'
import { Slots } from '@app/lib/layout'
import { EntitySubTree } from '@contember/interface'

export default () => {
	return (
		<>
			<Binding>
				<div className="flex flex-col gap-12">
					<Slots.Title>Header settings</Slots.Title>
					<Slots.Back>
						<BackButton />
					</Slots.Back>
					<EntitySubTree entity={'HeaderSettings(unique = One)'} setOnCreate="(unique = One)">
						<Slots.Actions>
							<PersistButton />
						</Slots.Actions>
						<HeaderSettingsForm />
					</EntitySubTree>
				</div>
			</Binding>
		</>
	)
}
